import React from 'react';
import { FaPlus, FaTimes } from 'react-icons/fa';

const SummaryTable = ({ rows, ebUsage, ldoUsage, onRowChange, onAddWasteMaterial, onRemoveWasteMaterial }) => {
  return (
    <div className="w-full mt-4 overflow-x-auto">
      <table className="min-w-full table-fixed bg-gray-800 border border-gray-700">
        <thead className="bg-teal-600 text-gray-100 border border-gray-700 text-xs">
          <tr className='text-nowrap'>
            <th className="border border-gray-700 p-2">Eb Usage</th>
            <th className="border border-gray-700 p-2">LDO Usage</th>
            <th className="border border-gray-700 p-2"> Wastage & Quantity</th>
            <th className="border border-gray-700 p-2">Condensate Quantity</th>
            <th className="border border-gray-700 p-2"> IP & Quantity</th>
            <th className="border border-gray-700 p-2">Residue Quantity</th>
            <th className="border border-gray-700 p-2">Actions</th>
          </tr>
        </thead>
        <tbody className="text-xs text-gray-700">
          {rows.map((row, index) => (
            <tr key={index}>
              {index === 0 && (
                <>
                  <td rowSpan={rows.length} className="border border-gray-700  text-white p-2 text-center">
                    {(ebUsage ?? 0).toFixed(2)}
                  </td>
                  <td rowSpan={rows.length} className="border border-gray-700 text-white p-2 text-center">
                    {(ldoUsage ?? 0).toFixed(2)}
                  </td>
                </>
              )}
              <td className="border border-gray-700 p-2">
                <input
                  type="text"
                  value={row.solvent?.name || ''} // Safe access with default value
                  onChange={(e) => onRowChange(index, 'solvent', { ...row.solvent, name:  e.target.value.replace(/[^a-zA-Z\s]/g, '')})}
                  className="w-full px-2 py-1 border-b bg-transparent text-white "
                  placeholder="Name"
                  readOnly={!row.editable}

                />
               <input
  type="text"
  value={row.solvent?.qty || 0} // Safe access with default value
  onChange={(e) => {
    const value = e.target.value;
    // Regex allows numbers with up to two decimal points
    if (/^\d*\.?\d{0,2}$/.test(value) || value === '') {
      onRowChange(index, 'solvent', { ...row.solvent, qty: value });
    }
  }}
  className="w-full mt-1 px-2 py-1 border-b bg-transparent text-white "
  placeholder="Solvent Qty"
  readOnly={!row.editable}
/>

              </td>
              <td className="border border-gray-700  p-2">
              <input
  type="text"
  value={row.condensateQty || 0} // Safe access with default value
  onChange={(e) => {
    const value = e.target.value;
    // Regex allows numbers with up to two decimal points
    if (/^\d*\.?\d{0,2}$/.test(value) || value === '') {
      onRowChange(index, 'condensateQty', value);
    }
  }}
  className="w-full px-2 py-1 border-b bg-transparent text-white "
  placeholder="Condensate Qty"
  readOnly={!row.editable}
/>

              </td>
              <td className="border border-gray-700 p-2">
                <input
                  type="text"
                  value={row.finishProduct?.name || ''} // Safe access with default value
                  onChange={(e) => onRowChange(index, 'finishProduct', { ...row.finishProduct, name: e.target.value.replace(/[^a-zA-Z\s]/g, '')})}
                  className="w-full px-2 py-1 border-b bg-transparent text-white"
                  placeholder="Finish Product"
                  readOnly={!row.editable}
                />
                <input
                  type="text"
                  value={row.finishProduct?.qty || 0} // Safe access with default value
                  onChange={(e) => {
                    const value = e.target.value;
                    // Regex allows numbers with up to two decimal points
                    if (/^\d*\.?\d{0,2}$/.test(value) || value === '') {
                      onRowChange(index, 'finishProduct', { ...row.finishProduct, qty: value });
                    }
                  }}
                  className="w-full mt-1 px-2 py-1 border-b bg-transparent text-white"
                  placeholder="Finish Product Qty"
                  readOnly={!row.editable}
                />
              </td>
              <td className="border border-gray-700 p-2">
                <input
                  type="text"
                  value={row.residueQty || 0} // Safe access with default value
                  onChange={(e) => {
                    const value = e.target.value;
                    // Regex allows numbers with up to two decimal points
                    if (/^\d*\.?\d{0,2}$/.test(value) || value === '') {
                      onRowChange(index, 'residueQty', value );
                    }
                  }}
                  className="w-full px-2 py-1 border-b bg-transparent text-white "
                  placeholder="Residue Qty"
                  readOnly={!row.editable}
                />
              </td>
              <td className="border border-gray-700 p-2 text-center">
                {rows.length > 1 && (
                  <button
                    className="px-2 py-1 text-red-500 rounded "
                    onClick={() => onRemoveWasteMaterial(index)}
                  >
                    <FaTimes />
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="flex  mt-2">
        <button
          className="flex items-center justify-center w-32 px-3 py-1.5 text-xs  rounded-md shadow-md bg-[#183b58] hover:bg-[#3081b8] text-white "
          onClick={onAddWasteMaterial}
        >
          <FaPlus className="mr-2" /> Add
        </button>
      </div>
    </div>
  );
};

export default SummaryTable;
